import React from "react";
import { Link, useParams } from "react-router-dom";
import {
  Row,
  Card,
  CardBody,
  CardTitle,
  Button,
  Spinner,
  Badge,
  Alert
} from "reactstrap";
import { Colxx, Separator } from "Components/CustomBootstrap";
import BreadcrumbContainer from "Components/BreadcrumbContainer";
import IntlMessages from "Util/IntlMessages";
import PerfectScrollbar from "react-perfect-scrollbar";
import { PERFECT_SCROLLBAR_MAX_320 } from "Constants/perfectScrollbarLayout";
import { useAsyncResource } from "../../../../../hooks/useAsyncResource";
import { suiteApi } from "../../../../../api/suiteAdapters";

export default function TicketingTicketDetailPage() {
  const { id } = useParams();
  const { data, loading, error } = useAsyncResource(
    () => suiteApi.ticketing.getTicket(id),
    [id]
  );

  return (
    <div className="suite-ticket-detail">
      <Row>
        <Colxx xxs="12">
          <BreadcrumbContainer
            heading={<IntlMessages id="suite.ticketing.ticket-detail" />}
          />
          <Separator className="mb-4" />
        </Colxx>
      </Row>
      <Row className="mb-3">
        <Colxx xs="12">
          <Button tag={Link} color="light" to=".." relative="path" className="mb-2">
            ← <IntlMessages id="suite.action.back" />
          </Button>
          {loading && <Spinner className="ms-2" />}
          {error && <p className="text-danger">{error}</p>}
        </Colxx>
      </Row>
      {data && data.slaStatus === "at_risk" && (
        <Row className="mb-3">
          <Colxx xxs="12">
            <Alert color="danger" className="py-2 mb-0">
              <strong>
                <IntlMessages id="suite.ticketing.sla-badge" />
              </strong>{" "}
              — First-response target may be missed. Escalation rules would run
              from your workflow engine.
            </Alert>
          </Colxx>
        </Row>
      )}
      {data && (
        <Row>
          <Colxx lg="8" className="mb-4">
            <Card className="mb-4">
              <CardBody>
                <div className="d-flex justify-content-between flex-wrap gap-2">
                  <CardTitle tag="h4" className="mb-0">
                    {data.subject}
                  </CardTitle>
                  <div>
                    <Badge color="info" className="me-1">
                      {data.status}
                    </Badge>
                    <Badge color="secondary">{data.priority}</Badge>
                  </div>
                </div>
                <p className="text-muted small mb-0 mt-2">
                  {data.id} · {data.requester} · {data.assignee}
                </p>
                <p className="mt-3 mb-0">{data.description}</p>
              </CardBody>
            </Card>
            <Card>
              <CardBody>
                <CardTitle>
                  <IntlMessages id="suite.ticketing.thread" />
                </CardTitle>
                <PerfectScrollbar style={PERFECT_SCROLLBAR_MAX_320}>
                  <ul className="list-unstyled mb-0">
                    {(data.thread || []).map((m, i) => (
                      <li key={i} className="mb-3 pb-3 border-bottom">
                        <div className="small text-muted">{m.at}</div>
                        <div className="font-weight-medium">{m.author}</div>
                        <div>{m.body}</div>
                      </li>
                    ))}
                  </ul>
                </PerfectScrollbar>
              </CardBody>
            </Card>
          </Colxx>
          <Colxx lg="4">
            <Card>
              <CardBody>
                <CardTitle>
                  <IntlMessages id="suite.ticketing.sidebar" />
                </CardTitle>
                <p className="text-muted small">
                  <IntlMessages id="suite.ticketing.sidebar-body" />
                </p>
                <Button color="primary" block className="mb-2">
                  <IntlMessages id="suite.ticketing.reply" />
                </Button>
                <Button
                  color="outline-secondary"
                  outline
                  block
                  tag={Link}
                  to="../../macros"
                  relative="path"
                >
                  <IntlMessages id="suite.ticketing.insert-macro" />
                </Button>
              </CardBody>
            </Card>
          </Colxx>
        </Row>
      )}
      {!loading && !data && !error && (
        <p className="text-muted">
          <IntlMessages id="suite.state.notfound" />
        </p>
      )}
    </div>
  );
}
